import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden">
      {/* Navigation */}
      <motion.nav
        className="fixed top-0 left-0 right-0 z-50 glass-effect"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <a href="/">
              <img
                src="/images/logominitgps.png"
                alt="MonitGPS Logo"
                className="h-12 w-auto cursor-pointer"
              />
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8 text-sm font-medium">
            <a href="/" className="hover:text-cyan-400 transition-colors">Strona Główna</a>
            <a href="/terms" className="hover:text-cyan-400 transition-colors">Regulamin</a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-cyan-400 focus:outline-none">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0a0a0a]/95 border-b border-white/10 flex flex-col px-6 py-4 space-y-4 text-sm font-medium backdrop-blur-xl">
            <a href="/" className="hover:text-cyan-400">Strona Główna</a>
            <a href="/terms" className="hover:text-cyan-400">Regulamin</a>
          </div>
        )}
      </motion.nav>

      {/* Content */}
      <section className="relative pt-32 pb-24 px-6 min-h-[70vh]">
        <div className="max-w-4xl mx-auto glass-effect rounded-3xl p-8 md:p-12">
          <h1 className="font-display font-black text-4xl md:text-5xl mb-2 text-cyan-400">
            Polityka <span className="text-white">Prywatności</span>
          </h1>
          <p className="text-gray-500 text-sm mb-8">Aplikacja RECC MonitGPS — obowiązuje od 21 sierpnia 2026</p>

          <div className="space-y-8 text-gray-300 leading-relaxed font-light">
            <div>
              <h2 className="text-xl text-white font-bold mb-3">1. O aplikacji</h2>
              <p>
                RECC MonitGPS to aplikacja mobilna przeznaczona dla zawodników rajdowych, używana wyłącznie
                podczas zapoznania z trasą rajdu ("recce"). Aplikacja przesyła pozycję GPS zawodnika do
                organizatora, aby serwis bezpieczeństwa wiedział, gdzie zawodnik aktualnie się znajduje.
                Niniejsza Polityka Prywatności opisuje, jakie dane zbiera aplikacja RECC MonitGPS, w jakim celu
                oraz jakie prawa przysługują użytkownikowi.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">2. Administrator danych</h2>
              <p>
                Administratorem danych jest MonitGPS. Kontakt w sprawach związanych z danymi osobowymi:{' '}
                <a href="mailto:monitgpssystem@gmail.com" className="text-cyan-400 hover:underline">
                  monitgpssystem@gmail.com
                </a>{' '}
                — jest to jedyny kanał kontaktu (aplikacja nie udostępnia numeru telefonu do obsługi).
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">3. Jakie dane zbieramy</h2>
              <p className="mb-3"><strong className="text-white">Dane lokalizacyjne (główny cel aplikacji):</strong></p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Pozycja GPS (szerokość/długość geograficzna), prędkość, kierunek jazdy (heading), dokładność (accuracy) oraz znacznik czasu.</li>
                <li>Dane wysyłane są co ok. 1 sekundę podczas aktywnej sesji zapoznania.</li>
                <li>
                  Lokalizacja jest zbierana tylko wtedy, gdy zawodnik jest zalogowany i sesja jest aktywna —
                  również gdy ekran telefonu jest zablokowany lub aplikacja działa w tle. Jest to niezbędne dla
                  bezpieczeństwa: śledzenie musi być ciągłe, nie tylko w momentach, gdy ekran jest włączony.
                </li>
                <li>Pozycja GPS trafia bezpośrednio z telefonu do serwera Traccar administrowanego przez MonitGPS (admin.monitgps.pl), bez pośredniczących serwerów innych niż sam Traccar.</li>
              </ul>

              <p className="mb-3"><strong className="text-white">Dane logowania i konta:</strong></p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Kod startowy (login) — kod przypisany zawodnikowi przez organizatora rajdu, nie jest to hasło wybierane przez użytkownika.</li>
                <li>Unikalny identyfikator instalacji aplikacji — losowy identyfikator wygenerowany przy pierwszym uruchomieniu i zapisany lokalnie w bezpiecznym magazynie systemowym telefonu (Android Keystore / iOS Keychain). Służy do powiązania jednego konta z jednym konkretnym telefonem — to samo konto nie może być używane jednocześnie na dwóch urządzeniach.</li>
                <li>Token sesji — wydawany po zalogowaniu, przechowywany lokalnie, służy do autoryzacji kolejnych zapytań do serwera.</li>
              </ul>
              <p className="mt-3">
                Serwer autoryzacyjny/konfiguracyjny (rc.monitgps.pl) nie widzi i nie przechowuje samych pozycji
                GPS — jedynie loguje sesję, wydaje konfigurację (numer startowy, nazwa kierowcy/pilota, nazwa
                rajdu — dane te wprowadza wcześniej organizator, nie użytkownik) oraz okresowo odbiera status
                "działa/nie działa", bez współrzędnych.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">4. Czego nie zbieramy</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Brak reklam oraz brak jakichkolwiek SDK-ów analitycznych lub śledzących stron trzecich (np. Google Analytics, Facebook SDK).</li>
                <li>Nie sprzedajemy i nie udostępniamy danych żadnym firmom trzecim w celach marketingowych.</li>
                <li>Brak dostępu do kontaktów, zdjęć, mikrofonu, aparatu ani SMS-ów.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">5. Uprawnienia systemowe</h2>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="border-b border-white/10 text-cyan-400 text-left">
                      <th className="py-2 pr-4 font-display">Uprawnienie</th>
                      <th className="py-2 font-display">Po co jest potrzebne</th>
                    </tr>
                  </thead>
                  <tbody className="align-top">
                    <tr className="border-b border-white/5">
                      <td className="py-3 pr-4 text-white font-medium whitespace-nowrap">Lokalizacja (w tym "zawsze"/w tle)</td>
                      <td className="py-3">Rdzeń funkcji aplikacji — wysyłka pozycji podczas zapoznania, również z zablokowanym ekranem.</td>
                    </tr>
                    <tr className="border-b border-white/5">
                      <td className="py-3 pr-4 text-white font-medium whitespace-nowrap">Powiadomienia</td>
                      <td className="py-3">Stała, widoczna notyfikacja informująca, że aplikacja aktywnie wysyła pozycję (wymóg systemu Android dla usług działających w tle) — aplikacja nie wysyła żadnych innych powiadomień.</td>
                    </tr>
                    <tr>
                      <td className="py-3 pr-4 text-white font-medium whitespace-nowrap">Wyjątek od optymalizacji baterii</td>
                      <td className="py-3">Aby system Android nie usypiał aplikacji w trakcie zapoznania — inaczej wysyłka pozycji mogłaby się przerywać.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">6. Jak długo przechowujemy dane</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Na telefonie: kod/token sesji oraz identyfikator instalacji są kasowane natychmiast po wylogowaniu lub zakończeniu zapoznania — ręcznie przez zawodnika, automatycznie o zaplanowanej godzinie, zdalnie przez organizatora lub po dłuższym bezruchu. Kasowanie danych przetrwa nawet restart telefonu.</li>
                <li>Po stronie serwera: pozycje GPS trafiają do systemu Traccar i są przechowywane przez czas trwania rajdu oraz rozsądny okres po nim, do celów bezpieczeństwa i rozliczenia zapoznania.</li>
                <li>Po zakończeniu sesji aplikacja przestaje zbierać i wysyłać jakiekolwiek dane — nie ma śledzenia poza aktywnym zapoznaniem.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">7. Kto ma dostęp do danych</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Pozycja GPS: organizator konkretnego rajdu (poprzez panel Traccar) oraz MonitGPS jako operator infrastruktury.</li>
                <li>Dane logowania/konta: MonitGPS (serwer rc.monitgps.pl).</li>
                <li>Żadne dane nie są przekazywane podmiotom niezwiązanym z organizacją rajdu i bezpieczeństwem zawodników.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">8. Prawa użytkownika</h2>
              <p>
                Zawodnik może w każdej chwili zakończyć wysyłanie danych, wylogowując się z aplikacji
                (przycisk "Zakończ RECC" / wylogowanie z menu). W związku z przetwarzaniem danych osobowych
                użytkownikowi przysługuje prawo dostępu do danych, ich sprostowania oraz usunięcia. W celu
                skorzystania z tych praw prosimy o kontakt pod adresem{' '}
                <a href="mailto:monitgpssystem@gmail.com" className="text-cyan-400 hover:underline">
                  monitgpssystem@gmail.com
                </a>.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">9. Zmiany Polityki Prywatności</h2>
              <p>
                Niniejsza Polityka może być okresowo aktualizowana, w szczególności w związku ze zmianami
                funkcjonalności aplikacji. Aktualna wersja jest zawsze dostępna pod adresem monitgps.pl/privacy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 glass-effect border-t border-white/5 mt-auto">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p>© 2026 MonitGPS. Wszystkie prawa zastrzeżone.</p>
            <a href="/terms" className="hover:text-cyan-400 transition-colors underline decoration-white/20 underline-offset-4">Regulamin</a>
          </div>
          <div className="mt-4 md:mt-0">
            <p>Profesjonalny monitoring dla sportów motorowych</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
